import { render } from "./Roteiros.vue?vue&type=template&id=ca1d6ad8&scoped=true&lang=pug"
import script from "./Roteiros.vue?vue&type=script&setup=true&lang=js"
export * from "./Roteiros.vue?vue&type=script&setup=true&lang=js"

import "./Roteiros.vue?vue&type=style&index=0&id=ca1d6ad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1d6ad8"]])

export default __exports__